import { useState, useEffect, useMemo } from 'preact/hooks'
import { formatName } from 'helpers/utils'
import { activeFilters, selectedValues } from 'snippets/plp-native/@store'
import { FILTER_SELECTORS } from 'libs/search-native/search-native-utils'

function PlpNativeFilterItems({ field, getLocalSelected }) {
  const { image, colors } = FILTER_SELECTORS.type
  const [selectedGroup, setSelectedGroup] = useState(selectedValues.value[field.field] || [])
  const [showMore, setShowMore] = useState(field.values.length > 7)

  const fieldValues = useMemo(() => (showMore ? [...field.values].slice(0, 7) : field.values), [showMore])
  const isMultiple = field.multiple

  useEffect(() => {
    let currentFilterSelected = selectedValues.value[field.field] || []

    if (field.prefix) {
      currentFilterSelected = currentFilterSelected.filter((item) => String(item.value).startsWith(field.prefix))
    }

    setSelectedGroup(currentFilterSelected)
  }, [selectedValues, activeFilters.value])

  const setSelectedItem = (event, label) => {
    const { value, checked } = event.target
    const selectedItem = { label, value }

    let updatedSelection = []

    if (checked) {
      updatedSelection = isMultiple ? [...selectedGroup, selectedItem] : [selectedItem]
    } else {
      updatedSelection = selectedGroup.filter((item) => item.value !== value)
    }

    setSelectedGroup(updatedSelection)
  }

  const displayValue = (display) => {
    const { type, value } = display

    if (type !== colors && type !== image) return null

    return (
      <span
        className="mr-1 inline-block size-3 rounded-full bg-cover"
        style={type === image ? `background-image: url('${value}&width=24')` : `background: ${value}`}
      />
    )
  }

  useEffect(() => {
    getLocalSelected(field.field, selectedGroup, field.prefix)
  }, [selectedGroup])

  if (!fieldValues.length) {
    return null
  }

  return (
    <>
      {fieldValues.map((item, index) => (
        <div className="flex items-center">
          <input
            id={`${item.value}-${index}`}
            type="checkbox"
            value={item.value}
            onChange={(e) => setSelectedItem(e, item.label)}
            checked={selectedGroup.some((i) => i.value === item.value)}
            className={isMultiple ? 'checkbox-input__input' : 'checkbox-input__radio'}
          />
          <label
            htmlFor={`${item.value}-${index}`}
            className="checkbox-input__label cursor-pointer capitalize text-neutral-700"
          >
            {displayValue(item.display)} {formatName(item.label)}
          </label>
        </div>
      ))}
      {field.values.length > 7 && (
        <button
          type="button"
          className="animation-link text-xs-medium mt-4 font-normal lg:text-xs"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? `Show ${field.values.length - 7} More` : 'Show Less'}
        </button>
      )}
    </>
  )
}

export default PlpNativeFilterItems
